import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from '../_store/actions'
import messages from '../_store/modules/messages'
import plans from '../_store/modules/plans'
import connections from '../_store/modules/connections'
import countries from '../_store/modules/countries'
import timezones from '../_store/modules/timezones'
import registration from '../_store/modules/registration'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    actions,
    modules: {
        messages,
        plans,
        connections,
        countries,
        timezones,
        registration,
    },
    strict: debug,
    // plugins: debug ? [createLogger()] : []
});
